module.exports = __webpack_public_path__ + "static/img/salepage-stk-promotion_36.36a6001.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/banner/promotion/salepage-stk-promotion_36.webp
// module id = B8E3
// module chunks = 134